// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_CriarSubcontaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/accounts/criar_subconta
 *
 * Creates a new subaccount via master account (ASAAS).
 * This is the primary method for creating new payment accounts.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_CriarSubcontaInput {
name: string
email: string
document: string
mobilePhone: string
incomeValue: number
address: string
addressNumber: string
province: string
postalCode: string
phone?: string
complement?: string
birthDate?: string
companyType?: string
provider_code?: string
franchise_ids?: number[]
}

registerContract('SubaccountsFranchises_CriarSubcontaInput', {
  name:          { type: 'string',  required: true },
  email:         { type: 'string',  required: true },
  document:      { type: 'string',  required: true },
  mobilePhone:   { type: 'string',  required: true },
  incomeValue:   { type: 'number',  required: true },
  address:       { type: 'string',  required: true },
  addressNumber: { type: 'string',  required: true },
  province:      { type: 'string',  required: true },
  postalCode:    { type: 'string',  required: true },
  phone:         { type: 'string',  required: false },
  complement:    { type: 'string',  required: false },
  birthDate:     { type: 'string',  required: false },
  companyType:   { type: 'string',  required: false },
  provider_code: { type: 'string',  required: false },
  franchise_ids: { type: 'array',   required: false },
})
